<template>
  <div class="row">
    <div class="col-md-12">
      <DataTable
        ref="datatable"
        :width="'100%'"
        :settings="datatable.settings"
        :dataColumns="datatable.columns"
        :dataFeed="datatable.dataFeed"
        :dataHandle="datatable.handle"
        :dataTableHeight="datatable.height"
        :defaultSortBy="datatable.sortBy"
        :defaultOrderBy="datatable.orderBy"
        :allowView="allowView"
        :allowEdit="allowEdit"
        :allowDelete="allowDelete"
        :hasContextMenu="hasContextMenu"
      >
        <template slot="menuButtons" slot-scope="props">
          <template v-if="props.item && props.item.data">
            <li @click="$refs.datatable.viewItem($event, props.item.data)" v-if="allowView(props.item.data)">View</li>
            <li @click="$refs.datatable.editItem($event, props.item.data)" v-if="allowEdit(props.item.data)">Edit</li>
            <li @click="$refs.datatable.confirmDelete($event, props.item.data)" v-if="allowDelete(props.item.data)">Delete</li>
          </template>
        </template>
      </DataTable>
      <!-- END DATA TABLE -->
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      pageSettings: {
        pageTitle: 'Role & Permissions',
        sectionName: 'user.rolePermission',
        sectionIcon: 'fas fa-users',
        type: this.pageType,
        useDefault: false,
        webService: this.$root.WebService.role,
        navigation: [
          { name: 'User', route: 'user.index' },
          { name: 'Role & Permission', route: 'user.rolePermission.index' },
        ],
        buttons: [],
        subSidebar: {
          buttons: [
            { name: 'User List', icon: 'fas fa-file-download', action: () => { this.$router.push({ name: 'user.index' }) } },
            { name: 'Roles & Permission', icon: 'fas fa-file-download', action: () => { this.$router.push({ name: 'user.rolePermission.index' }) } },
          ]
        }
      },
      datatable: {
        settings: {
          sectionName: 'user.rolePermission',
          webService: this.$root.WebService.role,
        },
        dataFeed: null,
        handle: null,
        columns: [
          { key: 'name', title: 'Name', type: 'input', width: '100%', value: null },
        ],
        sortBy: null,
        orderBy: 'desc',
        width: '100%',
        height: '70vh',
      },
      datas: [],
      userRoles: []
    }
  },
  created() {
    this.getUserRole()
  },
  mounted() {

    if( this.hasPermission('create role') ) this.pageSettings.buttons.push({ name: 'Add New Role', icon: 'fas fa-plus', action: this.addItem })

    this.$emit('setPageHeader', this.pageSettings)
    this.datatable.handle = (res) => this.datas = res.data.data
    this.datatable.dataFeed = {
      method: 'get',
      url: this.pageSettings.webService
    }
  },
  methods: {
    getUserRole() {
      this.$http
        .get(this.WebService.role)
        .then(response => {
          this.datatable.columns.roles.selectOptions.datas = this.userRoles = response.data.data
        })
        .catch(err => { })
        .finally(null)
    },
    addItem() {
      this.$router.push({ name: this.pageSettings.sectionName + '.create' })
    },
    exportData() {

    },
    importData() {

    },
    allowView(item) {
      return this.hasPermission('read role')
    },
    allowEdit(item) {
      return this.hasPermission('update role') && item.id !== 1
    },
    allowDelete(item) {
      return this.hasPermission('delete role') && item.id !== 1
    },
    hasContextMenu(item) {
      return this.allowView(item) || this.allowEdit(item) || this.allowDelete(item)
    }
  }
}
</script>